<template>
  <div class="irp-owner-cell ph-no-capture dd-privacy-mask">
    <template v-if="ownerName">
      <FontAwesomeIcon :icon="['fak', 'person']" class="irp-owner-cell__icon" />
      <span class="truncate">{{ ownerName }}</span>
    </template>
    <span v-else class="irp-owner-cell__empty">&mdash;</span>
  </div>
</template>

<script setup lang="ts">
import type { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import type {
  RecordFieldType,
  RecordOverviewPartnerType,
} from '@/types/individual_record';

import { ownerNameOf } from './irp';

const { params } = defineProps<{
  params: ICellRendererParams<RecordOverviewPartnerType>;
}>();

const ownerFields = computed<RecordFieldType[]>(
  () => params.data?.account_owners?.items?.[0]?.fields ?? [],
);

const ownerName = computed(() => ownerNameOf(ownerFields.value));
</script>

<style lang="pcss">
@reference "../../../css/theme.css";
.irp-owner-cell {
  @apply flex items-center gap-4 h-full w-full text-sm text-neutral-text;
}

.irp-owner-cell__icon {
  @apply text-neutral-accent shrink-0;
}

.irp-owner-cell__empty {
  @apply text-neutral-text-weak;
}
</style>
